import { BUILD_ID } from '../version';

export default function Version() {
  return (
    <div style={{ padding: '20px', fontFamily: 'monospace' }}>
      <h2>App Version Info</h2>
      <pre>{JSON.stringify({
        BUILD_ID,
        routes: [
          "/billing/subscribe",
          "/billing/subscribe/:plan", 
          "/billing/success",
          "/billing/cancel"
        ],
        timestamp: new Date().toISOString()
      }, null, 2)}</pre>
    </div>
  );
}
